import { redirect } from 'react-router'
import { getUserInLoader } from '@/systems/Authentication'
import { publicAction } from '@/data/loaders'

export function loadOrganizations() {
  return new Promise(function(resolve, reject) {
    getUserInLoader().then(function({ user, userdata }) {
      const manager_organizations = userdata.organizations.filter(o => o.roles.includes("admin"));
      if (manager_organizations.length == 1) {
        resolve(redirect("/organizations/"+manager_organizations[0].data._id))
      } else {
        resolve({});
      }
      resolve({});
    }).catch(reject);
  });
}

export function loadOrganization({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("getOrganization", { id: params.organization_id }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Organization not found", path: `/organizations`, status: 404 });
      }
    }).catch(reject);

  })
}

export function loadSubOrganizationsAndCourses({ request, params }) {
  return publicAction("getOrganizationDepartmentsAndCourses", { id: params.organization_id })
}

export function loadOrgPeople({ request, params }) {
  return publicAction("getOrganizationMembers", { id: params.organization_id })
}

export function loadOrgSettings({ request, params }) {
  return publicAction("getOrganizationSettings", { id: params.organization_id })
}